module.exports = __webpack_public_path__ + "static/media/edit-pen-no-fill.efe46ab9.svg";